import { Button, Card, Col, Row, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { FiCheckCircle } from "react-icons/fi";

const SubscriptionPlans = () => {
    let plansData = [
        {
            title: 'Essential CRM',
            price: '$500',
            maxUser: '200',
            getStartWith: 'Everything in Essential HR +',
            features: [{
                title: '',
                list: ['Blueprint', 'CPQ', 'SalesSignals', 'Inventory management', 'Webhooks', 'Assignment rules', 'Validation rules', 'Google Ads integration']
            }]
        },
        {
            title: 'PROFESSIONAL',
            price: '$500',
            maxUser: '200',
            getStartWith: 'Everything in Professional +',
            features: [{
                title: '',
                list: ['Zia - AI assistant', 'Territory management', 'Custom functions', 'Journey orchestration', 'Multi-user portals', 'Page layouts', 'Client scripts', 'Approval process', 'Sandbox']
            }]
        },
        {
            title: 'Enterprise',
            price: '$500',
            maxUser: '200',
            getStartWith: 'Everything in Premium +',
            features: [{
                title: '',
                list: ['Enhanced feature limits', 'Custom AI/ML platform', 'Advanced customization', 'Data preparation', 'Augmented Analytics', 'Data storytelling', 'Unified business insights', 'Advanced administration']
            }]
        }
    ]

    return (<>
        <div className="container-fluid py-3">
            <div className="available-plans">
                <div className="hstack justify-content-between mb-2">
                    <h6 className="fw-semibold mb-0">Subscription Plans</h6>
                    <ToggleButtonGroup type="radio" name="subscriptionPlans" defaultValue={'monthly'}
                        className="p-1 border bg-white rounded-2 mb-2">
                        <ToggleButton className="border-0 rounded-2 px-4"
                            id='radio-monthly'
                            variant="outline-dark" value={'monthly'}>
                            Monthly
                        </ToggleButton>
                        <ToggleButton className="border-0 rounded-2 px-4"
                            id='radio-yearly'
                            type="radio"
                            variant="outline-dark" value={'yearly'}>
                            Yearly
                        </ToggleButton>
                    </ToggleButtonGroup >
                </div>
                <Row xs={1} md={2} lg={3} xl={4} className="g-2 justify-content-center">
                    <Col>
                        <Card body className="border-0 h-100">
                            <div className="fs-4 fw-semibold">Essential HR +</div>
                            <div className="mb-2">
                                <span className="fs-3 fw-semibold">$500</span><span className="small text-secondary"> / month</span>
                            </div>
                            <div className="text-secondary">Max User : 200</div>
                            <Button variant="outline-primary w-100 my-2">Edit</Button>
                            <div className="fw-medium mb-2">Get Start with :</div>
                            <div className="fs-6 fw-semibold text-success">Basic +</div>
                            <div className="mt-3">
                                <div className="fs-6 fw-medium mb-2">Core HR/Employee Management</div>
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Employee Database</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>HR Administration</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Employee Self-Service (ESS)</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>HR Help Desk</span>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>
                    <Col>
                        <Card body className="border-0 h-100">
                            <div className="fs-4 fw-semibold">PROFESSIONAL</div>
                            <div className="mb-2">
                                <span className="fs-3 fw-semibold">$500</span><span className="small text-secondary"> / month</span>
                            </div>
                            <div className="text-secondary">Max User : 200</div>
                            <Button variant="outline-primary w-100 my-2">Edit</Button>
                            <div className="fw-medium mb-2">Get Start with :</div>
                            <div className="fs-6 fw-semibold text-success">Essential HR +</div>
                            <div className="mt-3">
                                <div className="fs-6 fw-medium mb-2">Workforce Management</div>
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Time and Attendance</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Leave Management</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Shift Scheduling</span>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>
                    <Col>
                        <Card body className="border-0 h-100">
                            <div className="fs-4 fw-semibold">PREMIUM</div>
                            <div className="mb-2">
                                <span className="fs-3 fw-semibold">$500</span><span className="small text-secondary"> / month</span>
                            </div>
                            <div className="text-secondary">Max User : 200</div>
                            <Button variant="outline-primary w-100 my-2">Edit</Button>
                            <div className="fw-medium mb-2">Get Start with :</div>
                            <div className="fs-6 fw-semibold text-success">Professional +</div>
                            <div className="mt-3">
                                <div className="fs-6 fw-medium mb-2">Talent Acquisition/Recruitment</div>
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Applicant Tracking System (ATS)</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Onboarding</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Talent Pools</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-2">
                                <div className="fs-6 fw-medium mb-2">Payroll and Compensation</div>
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Payroll Processing</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Benefits Administration</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Compensation Management</span>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>
                    <Col>
                        <Card body className="border-0 h-100">
                            <div className="fs-4 fw-semibold">Enterprise</div>
                            <div className="mb-2">
                                <span className="fs-3 fw-semibold">$500</span><span className="small text-secondary"> / month</span>
                            </div>
                            <div className="text-secondary">Max User : 200</div>
                            <Button variant="outline-primary w-100 my-2">Edit</Button>
                            <div className="fw-medium mb-2">Get Start with :</div>
                            <div className="fs-6 fw-semibold text-success">Premium +</div>
                            <div className="mt-3">
                                <div className="fs-6 fw-medium mb-2">Performance and Development</div>
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Performance Management</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Learning and Development (L&D)</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Succession Planning</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-2">
                                <div className="fs-6 fw-medium mb-2">Analytics and Reporting</div>
                                <ul className="list-unstyled vstack gap-2 mb-0">
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>HR Analytics</span>
                                    </li>
                                    <li className="hstack gap-2">
                                        <FiCheckCircle size={16} /> <span>Custom Reports</span>
                                    </li>
                                </ul>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    </>);
}

export default SubscriptionPlans;